export const CHAT_GPT_ROLES = {
	USER: 'user',
	SYSTEM: 'system',
	ASSISTANT: 'assistant',
};
